import React from 'react'

const LunchSearch = () => {
  return (
    <div>LunchSearch</div>
  )
}

export default LunchSearch